<template>
    <div class="clearfix text-center">
        <br><br>
        <h3>{{title}}</h3>
        <br><br>
        <p>
            {{content}}
        </p>
        <div class="text-center">
            <img src="../../../assets/images/route-no-schedule.png" class="img img-responsive" style="margin-left: auto;margin-right: auto;">
        </div>
    </div>
</template>

<script>
    export default {
        name: "NotFoundPage",
        props: {
            title: {
                type: String,
                default: 'Không tìm thấy'
            },
            content: {
                type: String,
                default: 'Không tìm thấy nội dung yêu cầu'
            }
        }
    }
</script>

<style scoped>
    .img-responsive {
        display: block;
        max-width: 100%;
        height: auto;
    }
</style>
